import React from 'react';
import {useStyles} from "./ValueIndicator.css";
import Paper from "@mui/material/Paper";

export default function ValueIndicator({
                                           size = 'small',
                                           highlighted = false,
                                           header,
                                           value
                                       }) {
    const classes = useStyles()

    if (size === 'big') {
        return <Paper className={highlighted ? classes.paperBigHighlighted : classes.paperBig}>
            <div className={classes.headerBig}>
                {header}
            </div>
            <div className={classes.valueBig}>
                {value}
            </div>
        </Paper>
    }

    return <Paper className={highlighted ? classes.paperSmallHighlighted : classes.paperSmall}>
        <div className={classes.headerSmall}>
            {header}
        </div>
        <div className={classes.valueSmall}>
            {value}
        </div>
    </Paper>
}